<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-md-3 contentLeft">
        <div v-for="item in itemsSortable2">
          <home-blog-list v-if="item.tipo === 'noticia'" :bloco="item"></home-blog-list>
          <home-now-in-radio-list v-if="item.tipo === 'agoranaradio'" :bloco="item"></home-now-in-radio-list>
          <home-poll v-if="item.tipo === 'enquete'" :bloco="item"></home-poll>
          <home-download-app v-if="item.tipo === 'aplicativo'" :bloco="item"></home-download-app>
          <home-social-networks-list v-if="item.tipo === 'redesocial'" :bloco="item"></home-social-networks-list>
          <home-top-musics-list v-if="item.tipo === 'topmusica'" :bloco="item"></home-top-musics-list>
          <home-image-gallery-list v-if="item.tipo === 'imagem'" :bloco="item"></home-image-gallery-list>
          <home-video-gallery-list v-if="item.tipo === 'video'" :bloco="item"></home-video-gallery-list>
          <home-banner v-if="item.tipo === 'destaque'" :bloco="item"></home-banner>
          <home-publicity v-if="item.tipo === 'publicidade'" :bloco="item"></home-publicity>
          <home-menu v-if="item.tipo === 'menu'" :bloco="item"></home-menu>
          <home-locutor-online v-if="item.tipo === 'locutor'" :bloco="item"></home-locutor-online>
          <home-message-boards v-if="item.tipo === 'recado'" :bloco="item"></home-message-boards>
          <home-request-music v-if="item.tipo === 'pedirmusica'" :bloco="item"></home-request-music>
          <home-album-list v-if="item.tipo === 'album'" :bloco="item"></home-album-list>
          <home-slides v-if="item.tipo === 'slider'" :bloco="item"></home-slides>
          <home-musics v-if="item.tipo === 'ultimasmusicas'" :bloco="item"></home-musics>
          <home-musics v-if="item.tipo === 'proximasmusicas'" :bloco="item"></home-musics>
          <home-links v-if="item.tipo === 'links'" :bloco="item"></home-links>
          <home-events v-if="item.tipo === 'evento'" :bloco="item"></home-events>
          <home-promotions v-if="item.tipo === 'promocao'" :bloco="item"></home-promotions>
          <module v-if="item.tipo === 'modulolivre'" :bloco="item"></module>
        </div>
      </div>
      <div class="col-xs-12 col-md-6 contentCenter">
        <div v-for="item in itemsSortable3">
          <chat v-if="item.tipo === 'chat'" :bloco="item"></chat>
          <home-blog-list v-if="item.tipo === 'noticia'" :bloco="item" :show-image="'true'"></home-blog-list>
          <home-now-in-radio-list v-if="item.tipo === 'agoranaradio'" :bloco="item"></home-now-in-radio-list>
          <home-poll v-if="item.tipo === 'enquete'" :bloco="item"></home-poll>
          <home-download-app v-if="item.tipo === 'aplicativo'" :bloco="item"></home-download-app>
          <home-social-networks-list v-if="item.tipo === 'redesocial'" :bloco="item"></home-social-networks-list>
          <home-top-musics-list v-if="item.tipo === 'topmusica'" :bloco="item"></home-top-musics-list>
          <home-image-gallery-list v-if="item.tipo === 'imagem'" :bloco="item"></home-image-gallery-list>
          <home-video-gallery-list v-if="item.tipo === 'video'" :bloco="item"></home-video-gallery-list>
          <home-banner v-if="item.tipo === 'destaque'" :bloco="item"></home-banner>
          <home-publicity v-if="item.tipo === 'publicidade'" :bloco="item"></home-publicity>
          <home-menu v-if="item.tipo === 'menu'" :bloco="item"></home-menu>
          <home-locutor-online v-if="item.tipo === 'locutor'" :bloco="item"></home-locutor-online>
          <home-message-boards v-if="item.tipo === 'recado'" :bloco="item"></home-message-boards>
          <home-request-music v-if="item.tipo === 'pedirmusica'" :bloco="item"></home-request-music>
          <home-album-list v-if="item.tipo === 'album'" :bloco="item"></home-album-list>
          <home-slides v-if="item.tipo === 'slider'" :bloco="item"></home-slides>
          <home-musics v-if="item.tipo === 'ultimasmusicas'" :bloco="item"></home-musics>
          <home-musics v-if="item.tipo === 'proximasmusicas'" :bloco="item"></home-musics>
          <home-links v-if="item.tipo === 'links'" :bloco="item"></home-links>
          <home-events v-if="item.tipo === 'evento'" :bloco="item"></home-events>
          <home-promotions v-if="item.tipo === 'promocao'" :bloco="item"></home-promotions>
          <module v-if="item.tipo === 'modulolivre'" :bloco="item"></module>
        </div>
      </div>
      <div class="col-xs-12 col-md-3 contentRight">
        <div v-for="item in itemsSortable4">
          <home-blog-list v-if="item.tipo === 'noticia'" :bloco="item"></home-blog-list>
          <home-now-in-radio-list v-if="item.tipo === 'agoranaradio'" :bloco="item"></home-now-in-radio-list>
          <home-poll v-if="item.tipo === 'enquete'" :bloco="item"></home-poll>
          <home-download-app v-if="item.tipo === 'aplicativo'" :bloco="item"></home-download-app>
          <home-social-networks-list v-if="item.tipo === 'redesocial'" :bloco="item"></home-social-networks-list>
          <home-top-musics-list v-if="item.tipo === 'topmusica'" :bloco="item"></home-top-musics-list>
          <home-image-gallery-list v-if="item.tipo === 'imagem'" :bloco="item"></home-image-gallery-list>
          <home-video-gallery-list v-if="item.tipo === 'video'" :bloco="item"></home-video-gallery-list>
          <home-banner v-if="item.tipo === 'destaque'" :bloco="item"></home-banner>
          <home-publicity v-if="item.tipo === 'publicidade'" :bloco="item"></home-publicity>
          <home-menu v-if="item.tipo === 'menu'" :bloco="item"></home-menu>
          <home-locutor-online v-if="item.tipo === 'locutor'" :bloco="item"></home-locutor-online>
          <home-message-boards v-if="item.tipo === 'recado'" :bloco="item"></home-message-boards>
          <home-request-music v-if="item.tipo === 'pedirmusica'" :bloco="item"></home-request-music>
          <home-album-list v-if="item.tipo === 'album'" :bloco="item"></home-album-list>
          <home-slides v-if="item.tipo === 'slider'" :bloco="item"></home-slides>
          <home-musics v-if="item.tipo === 'ultimasmusicas'" :bloco="item"></home-musics>
          <home-musics v-if="item.tipo === 'proximasmusicas'" :bloco="item"></home-musics>
          <home-links v-if="item.tipo === 'links'" :bloco="item"></home-links>
          <home-events v-if="item.tipo === 'evento'" :bloco="item"></home-events>
          <home-promotions v-if="item.tipo === 'promocao'" :bloco="item"></home-promotions>
          <module v-if="item.tipo === 'modulolivre'" :bloco="item"></module>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import {get} from '../helpers/api';
  import HomeBlogList from '../components/home/BlogList.vue';
  import HomeNowInRadioList from '../components/home/NowInRadioList.vue';
  import HomePoll from '../components/home/Poll.vue';
  import HomeDownloadApp from '../components/home/DownloadApp.vue';
  import HomeSocialNetworksList from '../components/home/SocialNetworksList.vue';
  import HomeTopMusicsList from '../components/home/TopMusicsList.vue';
  import HomeImageGalleryList from '../components/home/ImageGalleryList.vue';
  import HomeVideoGalleryList from '../components/home/VideoGalleryList.vue';
  import HomeLocutorOnline from '../components/home/LocutorOnline.vue';
  import HomeBanner from '../components/home/Banner.vue';
  import HomeMessageBoards from '../components/home/MessageBoards.vue';
  import HomeStatistics from '../components/home/Statistics.vue';
  import HomeCalendar from '../components/home/Calendar.vue';
  import HomeRequestMusic from '../components/home/RequestMusic.vue';
  import HomePublicity from '../components/home/Publicity.vue';
  import HomeMenu from '../components/home/Menu.vue';
  import HomeAlbumList from '../components/home/AlbumList.vue';
  import BlocosStorage from '../store/blocos';
  import HomeSlides from '../components/home/Slides.vue';
  import HomeMusics from '../components/home/Musics.vue';
  import HomeLinks from '../components/home/Links.vue';
  import HomeEvents from '../components/home/Events.vue';
  import HomePromotions from '../components/home/Promotions.vue';
  import Chat from "../components/home/Chat";
  import Module from "../components/home/Module";
  import Test from "../components/home/Test";

  export default {
    components: {
      Test,
      Module,
      Chat,
      HomeBlogList,
      HomeNowInRadioList,
      HomePoll,
      HomeDownloadApp,
      HomeSocialNetworksList,
      HomeTopMusicsList,
      HomeImageGalleryList,
      HomeVideoGalleryList,
      HomeLocutorOnline,
      HomeBanner,
      HomeMessageBoards,
      HomeStatistics,
      HomeCalendar,
      HomeRequestMusic,
      HomePublicity,
      HomeMenu,
      HomeAlbumList,
      HomeSlides,
      HomeMusics,
      HomeLinks,
      HomeEvents,
      HomePromotions
    },
    data() {
      return {
        itemsSortable2: this.$store.getters['getBlocos'].sortable2,
        itemsSortable3: this.$store.getters['getBlocos'].sortable3,
        itemsSortable4: this.$store.getters['getBlocos'].sortable4
      }
    },
    created() {
      let self = this;
      // self.itemsSortable2 = self.$store.getters['getBlocos'].sortable2;
      // self.itemsSortable3 = self.$store.getters['getBlocos'].sortable3;
      // self.itemsSortable4 = self.$store.getters['getBlocos'].sortable4;
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/Index.vue